// AI Generated File
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { AccPdfAccessibilityRemediationService } from './remediation.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';

interface RemediationResult {
    success: number;
    failure: number;
}

@Component({
    selector: 'acc-doc-pdf-accessibility-multiple-remediations-btn',
    standalone: false,
    template: `
        <a
            *ngIf="hasAccess()"
            [ngClass]="{ 'mon-disabled': disabled() }"
            (click)="!disabled() && confirmation()"
            monEventTrigger="actionTrigger"
            [monEventParams]="{action:'accessibility-bulk-remediation'}"
            [title]="'Request Remediation from selection' | translate"
            translate>
            Request Remediation from selection
        </a>
    `,
})
export class AccDocPdfAccessibilityMultipleRemediationsBtnComponent {
    @Input() pdfs?: any[];
    @Output() afterResolve = new EventEmitter<RemediationResult>();

    loading = false;

    constructor (
        private sessionService: SessionService,
        private accPdfAccessibilityRemediationService: AccPdfAccessibilityRemediationService,
        private monEventService: MonEventService,
    ) {}

    hasAccess (): boolean {
        return Boolean(this.sessionService.customer && this.sessionService.customer.plan_traits.clarity_pdf_remediation);
    }

    disabled (): boolean {
        return this.loading || !this.isPDFArray() || (this.pdfs?.length || 0) === 0 || this.areAllPDFSRemediated();
    }

    confirmation (): void {
        if (this.disabled()) {
            return;
        }

        let successes = 0;
        let failures = 0;

        const filteredPdfs = (this.pdfs || []).filter(pdf => !pdf.clarity_remediated);

        this.monEventService.run('remediationMultiBtnClick', { files: filteredPdfs.length });

        this.accPdfAccessibilityRemediationService.createRemediationDialog(() => {
            this.loading = true;

            const processRemediations = async () => {
                for (const pdf of filteredPdfs) {
                    try {
                        await this.createRemediation(pdf);
                        successes++;
                    } catch {
                        failures++;
                    }
                }

                this.loading = false;
                this.afterResolve.emit({ success: successes, failure: failures });
            };

            processRemediations();
        });
    }

    private isPDFArray (): boolean {
        return Array.isArray(this.pdfs);
    }

    private createRemediation (pdf: any): Promise<any> {
        return this.accPdfAccessibilityRemediationService.createRemediation(pdf);
    }

    private areAllPDFSRemediated (): boolean {
        if (!this.pdfs) {
            return true;
        }
        return this.pdfs.every(pdf => pdf.clarity_remediated);
    }
}
